import reducer from './reducers';

export { default as documentSelectors } from './selectors';
export { default as documentOperations } from './operations';
export { default as documentTypes } from './types';

export default reducer;
